import { PANEL_TYPES, PANEL_STATES } from "../projectWizardConstants.js";
import { OPERATIONS } from "../../../../constants/operations.js";

import * as Yup from "yup";
import * as Schemas from "../../../../components/forms/validationSchemas.js";

import { vpnBlockValidationSchema } from "../../../../components/vpns/vpnBlockValidationSchema.js";

export default {
  id: "add-vpn",
  type: "ADD_VPN_GATEWAY",
  modalCopyKey: "project_wizard.config_copy.add_vpn.modals",
  copyKey: "project_wizard.config_copy.add_vpn",

  initialValues: {
    provider: null,
    region: null,
    zone: null,

    virtualPrivateNetworkGateways: []
  },

  estimateConditions: ["resources"],

  steps: [
    {
      id: "resources",
      name: "Add Virtual Private Network",
      icon: "server",
      defaultEstimatePanel: false,
      panels: [
        {
          id: "providers",
          panelType: PANEL_TYPES.PROVIDER,
          permissionType: OPERATIONS.LIST,
          required: true,
          view: PANEL_STATES.ACTIVE
        },
        {
          id: "regions",
          panelType: PANEL_TYPES.REGION,
          permissionType: OPERATIONS.LIST,
          required: true,
          view: PANEL_STATES.INACTIVE,
          dependencies: [
            {
              name: "provider",
              view: PANEL_STATES.ACTIVE
            }
          ]
        },
        {
          id: "virtualPrivateNetworkGateways",
          panelType: PANEL_TYPES.VPN_GATEWAY,
          permissionType: OPERATIONS.CREATE,
          required: false,
          view: PANEL_STATES.ACTIVE,
          dependencies: [
            {
              name: "region",
              view: PANEL_STATES.ACTIVE
            }
          ]
        },
        {
          id: "estimate",
          panelType: PANEL_TYPES.ESTIMATE,
          view: PANEL_STATES.ACTIVE
        }
      ],
      panelDependencyIndex: ["provider", "region"],
      validationSchema: function (messages) {
        const objShape = {
          projectId: Yup.mixed().required(),
          provider: Schemas.dropdownSchema("Provider", messages),
          region: Schemas.dropdownSchema("Location", messages),
          zone: Schemas.dropdownSchema("Zone", messages, false),
          virtualPrivateNetworkGateways: Yup.array().of(
            vpnBlockValidationSchema(messages)
          )
        };
        return Yup.object().shape(objShape, ["projectId"]);
      }
    }
  ]
};
